import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { zip } from 'rxjs';

import { UserDetails } from '@bn/shared/core/api';

import { AuthService } from './auth.service';
import { UserDetailsStateService } from './user-details-state.service';

@Injectable({ providedIn: 'root' })
export class FluffeeService {
  readonly #authService = inject(AuthService);
  readonly #userDetailsService = inject(UserDetailsStateService);
  private isInitialized = false;

  constructor() {
    zip([this.#userDetailsService.getUserDetails(), this.#authService.getAuthStore()])
      .pipe(takeUntilDestroyed())
      .subscribe(([userDetails, authData]) => {
        if (this.isInitialized || !userDetails?.Id || !authData?.auth_token) return;

        this.initFluffee(userDetails.FirstName, authData.auth_token);
        this.isInitialized = true;
      });
  }

  initFluffee(userId: UserDetails['Id'], jwt: string): void {
    const fluffeeConf = document.createElement('script');
    fluffeeConf.type = 'text/javascript';
    fluffeeConf.innerHTML = `if (typeof fluffee_configure !== "undefined") { fluffee_configure('${userId}', '${jwt}', 'jwt'); }`;

    const firstScript = document.getElementsByTagName('script')[0];
    firstScript?.parentNode?.insertBefore(fluffeeConf, firstScript);
  }
}
